/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import type { useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery as useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$data } from './__types__/useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery';
import { PageCardInPageTreeHoverPreference } from './__types__/HoverPageCardsOptStatusQuery';

const useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = graphql`
	query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery {
		userPreferences {
			shouldShowCardOnPageTreeHover
		}
	}
`;
/**
 * @returns
 * - isHoverPageCardOptedIn: boolean - true if user is opted into hover page cards, false if we want to render tooltips instead
 */
export const useHoverPageCardsOptStatus = () => {
	const { isLicensed } = useSessionData();
	const { data } = useQuery<useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$data>(
		useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery,
		{
			skip: !isLicensed,
		},
	);

	// don't render popups for anon users.
	// This is after the useQuery because conditionally running hooks isn't allowed.
	if (!isLicensed) {
		return {
			isHoverPageCardOptedIn: false,
		};
	}

	const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;

	return {
		isHoverPageCardOptedIn: userPreference !== PageCardInPageTreeHoverPreference.NO_SHOW_PAGECARD,
	};
};
